import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

// TODO: same hook is in the channels
export const useNavigateToCalendar = () => {
  const navigate = useNavigate();

  return useCallback(async () => {
    await navigate(routes.calendar.index);
  }, [navigate]);
};
